import React from "react";
import { errorToast, successToast } from "./common/showtoast";
import ApiRequest from "./common/restservice";
import PageHeader from "./common/pageheader";

export default class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.UpdatePassword = this.UpdatePassword.bind(this);
    this.state = {
      oldpassword: "",
      newpassword: "",
      confirmpassword: "",
      loginortransaction: "login"
    }
  }
  componentDidMount() {
    if (this.props.match.params) {
      this.setState({
        loginortransaction: this.props.match.params.step ? this.props.match.params.step : "login"
      })
    }
  }
  UNSAFE_componentWillReceiveProps(newprops) {
    if (newprops.match.params) {
      this.setState({
        loginortransaction: newprops.match.params.step ? newprops.match.params.step : "login"
      })
    }
  }
  async UpdatePassword() {
    if (!this.state.oldpassword) {
      errorToast("Enter valid current password");
      return;
    } else if (!this.state.newpassword) {
      errorToast("Enter valid new password");
      return;
    } else if (!this.state.confirmpassword) {
      errorToast("Enter valid confirm password");
      return;
    } else if (this.state.newpassword !== this.state.confirmpassword) {
      errorToast("Password Mismatched");
      return;
    }
    let url = this.state.loginortransaction === "transaction" ? "ChangetPassword.asp" : "ChangePassword.asp";
    let res = await ApiRequest(url, "POST", this.state, { Authorization: localStorage.getItem("token") });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    successToast(res.message);
    this.setState({
      oldpassword: "",
      newpassword: "",
      confirmpassword: ""
    })
  }
  render() {
    return (
      <div>
        <PageHeader title={`Change ${this.state.loginortransaction} Password`} />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
            <div className="card overflow-hidden dash1-card border-0 ">
              <form className="card-body" onSubmit={(e) => { e.preventDefault(); this.UpdatePassword(); }}>
                <h5 className=" mt-3 mb-3">Change {this.state.loginortransaction} Password</h5>
                <div className="search-element row mb-5">
                  <div className="input-container">
                    <i className="las la-lock inputicon"></i>
                    <input type="password" className="form-control col-lg-4" placeholder="Old password" aria-label="Old password" tabIndex="1" onChange={(e) => {
                      this.setState({
                        oldpassword: e.target.value
                      })
                    }} value={this.state.oldpassword} />
                  </div>
                </div>
                <div className="search-element row mb-5">
                  <div className="input-container">
                    <i className="las la-lock inputicon"></i>
                    <input type="password" className="form-control col-lg-4" placeholder="New password" aria-label="New password" tabIndex="1" onChange={(e) => {
                      this.setState({
                        newpassword: e.target.value
                      })
                    }} value={this.state.newpassword} />
                  </div>
                </div>
                <div className="search-element row mb-5">
                  <div className="input-container">
                    <i className="las la-lock inputicon"></i>
                    <input type="password" className="form-control col-lg-4" placeholder="Confirm new password" aria-label="Confirm new password" tabIndex="1" onChange={(e) => {
                      this.setState({
                        confirmpassword: e.target.value
                      })
                    }} value={this.state.confirmpassword} />
                  </div>
                </div>
                <button className="ml-2 mb-5 btn primebtn" type="submit">Update</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}